/**
 * Vuetify theme color definitions for all 4 theme variants.
 *
 * Vuetify 2 only supports "light" and "dark" theme keys.
 * Colorblind variants are applied by dynamically updating
 * vuetify.framework.theme.themes[key] at runtime.
 */

export const themeColors = {
  light: {
    primary: "#5b64ee",
    secondary: "#9BABBD",
    tertiary: "#F1F3FF",
    accent: "#FF3553",
    error: "#F64E60",
    info: "#8950FC",
    success: "#1BC5BD",
    warning: "#FFA800",
    background: "#F2F5FA",
    surface: "#ffffff"
  },
  dark: {
    primary: "#a5aaf6",
    secondary: "#7c7c80",
    tertiary: "#494a4f",
    accent: "#FF3553",
    error: "#ec9099",
    info: "#d9d6fe",
    success: "#81bda1",
    warning: "#fbc278",
    background: "#222326",
    surface: "#2d2e32"
  },
  "light-colorblind": {
    primary: "#5b64ee",
    secondary: "#9BABBD",
    tertiary: "#F1F3FF",
    accent: "#FF3553",
    error: "#ef6820",
    info: "#8950FC",
    success: "#2e90fa",
    warning: "#f79009",
    background: "#f2f5fa",
    surface: "#ffffff"
  },
  "dark-colorblind": {
    primary: "#a5aaf6",
    secondary: "#7c7c80",
    tertiary: "#494a4f",
    accent: "#FF3553",
    error: "#f6ac84",
    info: "#d9d6fe",
    success: "#8cc2fc",
    warning: "#fbc278",
    background: "#222326",
    surface: "#2d2e32"
  }
};
